import SVGInject from "@iconfu/svg-inject/dist/svg-inject";

const svgInject = {};

svgInject.init = () => {
    SVGInject(document.querySelectorAll("img.js-svg-inject"));
};

export default svgInject;
